// DS: i3.29
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
const Attach = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        stroke: "currentColor",
        strokeWidth: "0.6",
        d: "M11.415 7.905a.332.332 0 010-.47l.664-.663a2.016 2.016 0 00-2.85-2.85L3.92 9.227a2.016 2.016 0 002.85 2.85l2.815-2.814a.843.843 0 00.001-1.192.84.84 0 00-1.188-.001L6.564 9.903a.332.332 0 01-.47-.47h0l1.834-1.831a1.505 1.505 0 112.128 2.132L7.24 12.548a2.68 2.68 0 01-3.79-3.79L8.76 3.453a2.68 2.68 0 013.79 3.79l-.665.663c-.13.13-.34.13-.47 0z",
        clipRule: "evenodd"
    })));
};
Attach.displayName = 'Attach';
export default Attach;
